var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive
    ? _c(
        "div",
        { staticClass: "c-results__page" },
        [
          _c("p", { staticClass: "c-results__summary" }, [
            _vm._v(
              '\n    You searched for "' +
                _vm._s(_vm.searchTerm) +
                '", we have found\n    ' +
                _vm._s(_vm.totalResults) +
                " results.\n  "
            )
          ]),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2482e580", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2482e580","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/results/SearchPage.vue
// module id = 632
// module chunks = 0